import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class TagApi {
    
    
    static activar(id, token ) {  
       return $.ajax({
        	url: getLocacion()+ "/api/tag/activar/"+id,
           headers: {"Authorization": "Bearer " + token.idToken},
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token ) {  
       return $.ajax({
        	url: getLocacion()+ "/api/tag/"+id,
           headers: {"Authorization": "Bearer " + token.idToken},
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getTagList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
			url: getLocacion()+ "/api/tag?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos,
			headers: {"Authorization": "Bearer " + token.idToken},
             statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getTag(id, token ) {  
         return $.ajax({
			url: getLocacion()+ "/api/tag/"+id,
			headers: {"Authorization": "Bearer " + token.idToken},
             statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(tag, token ) {          
      let tagEnvio = Object.assign({}, tag);
		let comando="POST";
		if (tagEnvio.id > 0) {
			comando="PUT";			
		} 
		tagEnvio=JSON.stringify(tagEnvio);
		return $.ajax({
			url: getLocacion()+ "/api/tag/",
            headers: {"Authorization": "Bearer " + token.idToken},
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: tagEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    static getTagCombo( token ) {

		return $.ajax({
			url: getLocacion()+ "/api/tag/combo/",
            headers: {"Authorization": "Bearer " + token.idToken},
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     

    
}